<template>
  <div
    :class="badgeClasses"
    :id="badgeId"
  >
    {{ badgeStr }}
  </div>
</template>
<script>
import { v4 as uuidv4 } from 'uuid'

export default {
  props: {
    badgeId: {
      type: String,
      default: uuidv4
    },

    badgeSmall: {
      type: Boolean,
      default: false
    },

    badgeTypeFalse: {
      type: String,
      default: 'secondary'
    },

    badgeTypeTrue: {
      type: String,
      default: 'primary'
    },

    badgeVal: {
      type: Boolean,
      default: false
    },

    falseStr: {
      type: String,
      default: 'No'
    },

    trueStr: {
      type: String,
      default: 'Yes'
    }
  },

  computed: {
    badgeClasses () {
      let str = `badge badge-${this.badgeTypeClass}`

      if (this.badgeSmall) {
        str += ` badge-sm`
      }

      return str
    },

    badgeTypeClass () {
      return this.badgeVal ? this.badgeTypeTrue : this.badgeTypeFalse
    },

    badgeStr () {
      return this.badgeVal ? this.trueStr : this.falseStr
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/BooleanBadge.vue